import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserPanelRoutingModule } from './user-panel-routing.module';
import { UserPanelComponent } from './user-panel.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { EventsComponent } from './events/events.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { FeaturesStyleTwoComponent } from "./home/features-style-two/features-style-two.component";
import { FunfactsStyleOneComponent } from "./home/funfacts-style-one/funfacts-style-one.component";
import { PremiumAccessComponent } from './home/premium-access/premium-access.component';
import { ContactComponent } from './contact/contact.component';
import { CoursesComponent } from './courses/courses.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ApplyCourseComponent } from './home/apply-course/apply-course.component';
import { InstructorStyleTwoComponent } from './home/instructor-style-two/instructor-style-two.component';
import { OnlineTrainingAboutComponent } from './home/online-training-about/online-training-about.component';
import { OnlineTrainingBannerComponent } from './home/online-training-banner/online-training-banner.component';
import { OnlineTrainingCoursesComponent } from './home/online-training-courses/online-training-courses.component';
import { HomeComponent } from './home/home.component';
import { CategoryCoursesComponent } from './category-courses/category-courses.component';
import { SubCategoryCourseComponent } from './sub-category-course/sub-category-course.component';
import { SharedModule } from '../../shared/shared.module';


@NgModule({
  declarations: [
    UserPanelComponent,
    HeaderComponent,
    FooterComponent,
    EventsComponent,
    AboutUsComponent,
    PremiumAccessComponent,
    FeaturesStyleTwoComponent,
    FunfactsStyleOneComponent,
    ContactComponent,
    CoursesComponent,
    LoginComponent,
    RegisterComponent,
    ApplyCourseComponent,
    FunfactsStyleOneComponent,
    InstructorStyleTwoComponent,
    OnlineTrainingAboutComponent,
    OnlineTrainingBannerComponent,
    OnlineTrainingCoursesComponent,
    HomeComponent,
    CategoryCoursesComponent,
    SubCategoryCourseComponent,
    CoursesComponent
  ],
  imports: [
    CommonModule,
    UserPanelRoutingModule,
    ReactiveFormsModule,
    CarouselModule,
    FormsModule,
    SharedModule
  ]
})
export class UserPanelModule { }
